module.exports = __webpack_public_path__ + "static/assets/f4ecefd4a732f5558dc53b0ccd039caa.png";